module.exports = __webpack_public_path__ + "img/es-calculator-frame.b7044d1d.png";